import { subscribeToEvent } from '../tools/event-subscribe';

export function scrollSpeedCollector(onData) {
  const data = [];
  let lastTarget,
    startTime,
    lastTime,
    lastTop,
    lastLeft,
    moveLeft = 0,
    moveTop = 0;
  let timeoutId;

  /**
     *
     * @param {Event} e
     */
  function handleScroll(e) {
    let target;
    if (e.target instanceof HTMLDocument) {
      target = e.target.scrollingElement;
    } else {
      target = e.target;
    }
    const { scrollTop, scrollLeft } = target;

    if (lastTarget) {
      if (lastTarget != e.target) {
        scoreLastTarget();
      } else if (lastTime) {
        moveTop += Math.abs(scrollTop - lastTop);
        moveLeft += Math.abs(scrollLeft - lastLeft);
      }
    }

    if (!startTime) {
      startTime = e.timeStamp;
    }

    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    timeoutId = setTimeout(scoreLastTarget, 1000);

    lastTarget = e.target;
    lastTime = e.timeStamp;
    lastTop = scrollTop;
    lastLeft = scrollLeft;
  }

  function scoreLastTarget() {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    if (moveLeft || moveTop) {
      const d = Math.sqrt(Math.pow(moveLeft, 2) + Math.pow(moveTop, 2));
      const v = d / Math.max(lastTime - startTime, 100) * 1000;

      const scroll = { d, v };
      data.push(scroll);
      onData(scroll);
    }

    moveLeft = moveTop = 0;
    startTime = null;
  }

  const subscriptions = [
    subscribeToEvent(window, 'scroll', handleScroll, { capture: true }),
  ];

  function stop() {
    subscriptions.forEach(u => u());
  }

  function toString() {
    if (data.length) {
      const summ = data.reduce((p, c) => ({ d: p.d + c.d, v: p.v + c.v }));
      let d = summ.d / data.length,
        v = summ.v / data.length;
      return `${Math.round(d)}|${Math.round(v)}`;
    }
    return '';
  }

  return {
    data,
    toString,
    stop,
  };
}



// WEBPACK FOOTER //
// ./src/lib/collectors/scroll-speed.js